import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    notification,
    Form,
    Select,
    Input,
} from "antd";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { baseUrl } from "../../config";

const { Item } = Form;
const { Option } = Select;

function SettingForm() {
    const { settingId } = useParams(); // Extract reportElementId from URL
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [bannerImage, setBannerImage] = useState('');

    useEffect(() => {
        // Check if reportElementId exists to determine if it's an update mode
        if (settingId) {
            setIsUpdateMode(true);
            fetchDetails();
        }
    }, [settingId]);

    const fetchDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/page-content/${settingId}`);
            if (response.status === 200) {
                form.setFieldsValue(response.data.result); // Populate form fields with fetched data
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    const onFinish = async (values) => {
        try {

            if (isUpdateMode) {
                values.id = settingId;
                const response = await axios.patch(`${baseUrl}/api/page-content`, values, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Page content updated successfully!',
                        placement: 'topRight'
                    });
                    navigate('/page-management');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            } else {
                const response = await axios.post(`${baseUrl}/api/page-content`, values, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Page content added successfully!',
                        placement: 'topRight'
                    });
                    form.resetFields();
                    navigate('/page-management');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    return (
        <div className="tabled">
            <Row gutter={[24, 0]}>
                <Col xs="24" xl={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title={isUpdateMode ? "Update Page Management" : "Add Page Management"}
                    >
                        <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Page Title"
                                        name="title"
                                        rules={[{ required: true, message: 'Please enter page title.' }]}
                                    >
                                        <Input placeholder="Please enter page title" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Page"
                                        name="page"
                                        rules={[{ required: true, message: 'Please select page.' }]}
                                    >
                                        <Select placeholder="Please select page">
                                            <Option value="privacy-policy">Privacy Policy</Option>
                                            <Option value="terms-conditions">Terms and Conditions</Option>
                                            <Option value="child-safety">Child Safety</Option>
                                            <Option value="gdpr-statement">GDPR Statement</Option>
                                            <Option value="disclaimer">Disclaimer</Option>
                                            <Option value="ip-notice">IP Notice</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col xs={24} sm={24} lg={24}>
                                    <Item
                                        label="Content"
                                        name="content"
                                        rules={[{ required: true, message: 'Please enter content.' }]}
                                    >
                                        <JoditEditor />
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item>
                                        <Button type="primary" htmlType="submit">
                                            {isUpdateMode ? "Update" : "Add"}
                                        </Button>
                                    </Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default SettingForm;
